import { parrotApi } from '@libs/openapi';
import { useEffect, useState } from 'react';
import { OpenapiClientParrotVault } from 'src/openapi/parrot-vault';
import { useRefreshTime } from './use-refresh';

export const useVaultRevenue = () => {
  const { refreshTime } = useRefreshTime();
  const [revenue, setRevenue] =
    useState<OpenapiClientParrotVault.GetVaultStatsChartRevenuesResponse>();

  const getVaultRevenues = async () => {
    const result = await parrotApi.get('/vault/stats/chart/revenues', {});
    setRevenue(result);
  };

  useEffect(() => {
    let timer: NodeJS.Timeout | undefined;
    const loop = () => {
      getVaultRevenues();
      timer = setTimeout(() => {
        loop();
      }, 60 * 1000);
    };
    loop();
    return () => {
      clearTimeout(timer);
    };
  }, [refreshTime]);

  return {
    revenue,
  };
};
